import { render, staticRenderFns } from "./Conta.vue?vue&type=template&id=4531b824&scoped=true"
import script from "./Conta.vue?vue&type=script&lang=js"
export * from "./Conta.vue?vue&type=script&lang=js"
import style0 from "./Conta.vue?vue&type=style&index=0&id=4531b824&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4531b824",
  null
  
)

export default component.exports